const state = {
    Appeal: {
        filters: {
            categories: 'all',
            appeal_tags: 'all',
        },
        paged: 1,
        search_term: '',
    },
    Blog: {
        filters: {
            categories: 'all',
            subjects: 'all',
        },
        paged: 1,
        search_term: '',
    },
    Job: {
        filters: {
            categories: 'all',
            job_types: 'all',
        },
        paged: 1,
        search_term: '',
    },
    Story: {
        filters: {
            categories: 'all',
            subjects: 'all',
        },
        paged: 1,
        search_term: '',
    },
    CentenaryStory: {
        filters: {
            themes: 'all',
            decades: 'all',
        },
        paged: 1,
        search_term: '',
    },
    Team: {
        filters: {
            categories: 'all',
            positions: 'all'
        },
        paged: 1,
        search_term: '',
    },
    Event: {
        filters: {
            categories: 'all',
            event_categories: 'all',
            dates: 'all',
        },
        paged: 1,
        search_term: '',
    },
};

const getters = {
    form: (state) => (postType) => state[postType],
    hasFilters: (state) => (postType) => {
        for (let filter in state[postType]['filters']) {
            if (filter !== 'all') {
                return true;
            }
        }
        return false;
    }
};

const actions = {
    updateFormValue({commit}, {postType, key, value, filter}) {
        if (filter) {
            commit('UPDATE_FILTERS_FORM_VALUE', {postType, key, value});
        } else {

            commit('UPDATE_FORM_VALUE', {postType, key, value});
        }
    }
};

const mutations = {
    UPDATE_FILTERS_FORM_VALUE(state, {postType, key, value}) {
        state[postType].filters[key] = value;
    },
    UPDATE_FORM_VALUE(state, {postType, key, value}) {
        state[postType][key] = value;
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
